import type { GridLines } from '../components/grid/GridLine.js';

/**
 * Checks that the rendered lines coordinates match with those of the specification lines.
 *
 * @param renderedLines -
 * @param lines -
 */
export function toMatchLines(renderedLines: HTMLElement[], lines: GridLines) {
  const fn = this.utils as {
    printReceived: (msg: unknown) => string;
    printExpected: (msg: unknown) => string;
  };
  for (let i = 0; i < renderedLines.length; i++) {
    const renderedLine = renderedLines[i];
    const [x1, y1, x2, y2] = [
      renderedLine.getAttribute('x1'),
      renderedLine.getAttribute('y1'),
      renderedLine.getAttribute('x2'),
      renderedLine.getAttribute('y2'),
    ];
    const { from, to } = lines[i];
    const [fromX, fromY, toX, toY] = [
      from.x?.toString(),
      from.y?.toString(),
      to.x?.toString(),
      to.y?.toString(),
    ];

    const pass = x1 === fromX && y1 === fromY && x2 === toX && y2 === toY;

    if (!pass) {
      return {
        message: () =>
          `expected rendered line coordinates ${fn.printReceived({
            x1,
            y1,
            x2,
            y2,
          })} to match ${fn.printExpected({
            x1: fromX,
            y1: fromY,
            x2: toX,
            y2: toY,
          })}`,
        pass,
      };
    }
  }

  return {
    message: () =>
      `expected rendered lines ${fn.printReceived(
        renderedLines,
      )} to match ${fn.printExpected(lines)}`,
    pass: true,
  };
}

expect.extend({
  toMatchLines,
});

declare global {
  // oxlint-disable-next-line typescript/no-namespace
  namespace jest {
    interface Matchers<R> {
      toMatchLines(lines: GridLines): R;
    }
  }
}
